<div (click)="!loading ? picker.click() : null" class="img"></div>

<div #picker class="picker">
  <ng-container *ngIf="value?.length !== 0">
    <div class="detail" *ngFor="let item of value">
      <app-image
        [fileid]="item"
        width="70px"
        height="70px"
        (click)="preview(item)"
      >
      </app-image>
      <mat-icon (click)="clear(item)">close</mat-icon>
    </div>
  </ng-container>
  <ng-container *ngIf="value.length < 5">
    <label for="file-input">
      <img
        src="../../../../assets/images/workorder/upload.webp"
        width="58"
        height="58"
        alt=""
      />
    </label>

    <input
      type="file"
      id="file-input"
      accept="image/png,image/jpeg"
      style="opacity: 0; width: 1px"
      (change)="onFileChange($event)"
    />
  </ng-container>
</div>
